import format from 'date-fns/format';
import { observer } from 'mobx-react';
import { T } from '../../../Translations';

export interface Props {
  time: Date;
  disabled: boolean;
  setTime: (date: string) => void;
}

const dateToLocalTime = (time: Date) => format(time, 'HH:mm');

function TimeInput({ time, setTime, disabled }: Props) {
  return (
    <div className="flex flex-col mr-2">
      <label className="font-semibold text-sm">
        <T kind="Time" />
      </label>
      <input
        type="time"
        value={dateToLocalTime(time)}
        onChange={(e) => setTime(e.target.value)}
        name="send-time"
        className="rounded border-gray-300 w-36 disabled:bg-gray-50 disabled:text-gray-400"
        disabled={disabled}
      />
    </div>
  );
}

export default observer(TimeInput);
